import createIcon from '../../createIcon';

/**
 * @component @name Sd
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g1QzMuODkgMyAzIDMuOSAzIDVWMTlDMyAyMC4xIDMuODkgMjEgNSAyMUgxOUMyMC4xIDIxIDIxIDIwLjEgMjEgMTlWNUMyMSAzLjkgMjAuMSAzIDE5IDNaTTEzIDlIMTdDMTcuNTUgOSAxOCA5LjQ1IDE4IDEwVjE0QzE4IDE0LjU1IDE3LjU1IDE1IDE3IDE1SDEzVjlaTTkuNSAxMy41VjEyLjVIN0M2LjQ1IDEyLjUgNiAxMi4wNSA2IDExLjVWMTBDNiA5LjQ1IDYuNDUgOSA3IDlIMTBDMTAuNTUgOSAxMSA5LjQ1IDExIDEwVjExSDkuNVYxMC41SDcuNVYxMS41SDEwQzEwLjU1IDExLjUgMTEgMTEuOTUgMTEgMTIuNVYxNEMxMSAxNC41NSAxMC41NSAxNSAxMCAxNUg3QzYuNDUgMTUgNiAxNC41NSA2IDE0VjEzSDcuNVYxMy41SDkuNVpNMTQuNSAxMy41SDE2LjVWMTAuNUgxNC41VjEzLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Sd = createIcon('Sd', [
  [
    'path',
    {
      d: 'M19 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM13 9H17C17.55 9 18 9.45 18 10V14C18 14.55 17.55 15 17 15H13V9ZM9.5 13.5V12.5H7C6.45 12.5 6 12.05 6 11.5V10C6 9.45 6.45 9 7 9H10C10.55 9 11 9.45 11 10V11H9.5V10.5H7.5V11.5H10C10.55 11.5 11 11.95 11 12.5V14C11 14.55 10.55 15 10 15H7C6.45 15 6 14.55 6 14V13H7.5V13.5H9.5ZM14.5 13.5H16.5V10.5H14.5V13.5Z',
      key: 'ui8a0',
    },
  ],
]);

export default Sd;
